import { render, staticRenderFns } from "./MessageRecord.vue?vue&type=template&id=13ac25a8&scoped=true"
import script from "./MessageRecord.vue?vue&type=script&lang=js"
export * from "./MessageRecord.vue?vue&type=script&lang=js"
import style0 from "./MessageRecord.vue?vue&type=style&index=0&id=13ac25a8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ac25a8",
  null
  
)

export default component.exports